import _ from 'lodash';
import { ImageExtractionResponse } from '@wix/media-platform-js-client/dist/mjs/src/platform/management/responses/image-extraction-response';

import { METADATA_ACTIONS } from '../../../../../redux/files/metadata.actions';
import { Action } from '../../../../../redux/redux.types';
import {
  FileMetadata,
  isImageMetadata,
} from '../../../../../types/media-assets';

import { IMAGE_FEATURES_ACTIONS } from './image-features.actions';
import { ImageFeaturesState } from './image-features.types';

const defaultState: ImageFeaturesState = {
  entities: {},
  isLoading: false,
};

export const imageFeatures = (
  state: ImageFeaturesState = defaultState,
  { type, payload }: Action,
): ImageFeaturesState => {
  switch (type) {
    case METADATA_ACTIONS.METADATA_GET_SUCCESS:
      const metadata: FileMetadata = payload.rawResponse;
      const { fileId } = payload.additionalData;

      if (!isImageMetadata(metadata) || !metadata.features) {
        return state;
      }

      return {
        isLoading: false,
        entities: {
          [fileId]: metadata.features,
        },
      };

    case IMAGE_FEATURES_ACTIONS.EXTRACT_IMAGE_START: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case IMAGE_FEATURES_ACTIONS.EXTRACT_IMAGE_SUCCESS: {
      const response: ImageExtractionResponse = _.get(payload, 'rawResponse');
      const fileId = _.get(payload, 'additionalData.fileId');

      return {
        entities: {
          ...state.entities,
          [fileId]: _.pick(response, [
            'colors',
            'explicitContent',
            'faces',
            'labels',
          ]),
        },
        isLoading: false,
      };
    }

    case IMAGE_FEATURES_ACTIONS.EXTRACT_IMAGE_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }

    default:
      return state;
  }
};
